import React, { useState } from 'react';

const Contact = ({ data, ui }) => {
   const [name, setName] = useState('');
   const [subject, setSubject] = useState('');
   const [email, setEmail] = useState('');
   const [message, setMessage] = useState('');

   const handleSubmit = (e) => {
      e.preventDefault();
      const body = `${name} (${email})\n\n${message}`;
      window.location.href = `mailto:${data.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
   }

   return (
      <section id="contact">
         <div className="row section-head">
            <div className="two columns header-col">
               <h1><span>{ui.getInTouch}</span></h1>
            </div>
            <div className="ten columns">
               <p className="lead">{data?.contactmessage}</p>
            </div>
         </div>

         <div className="row">
            <div className="eight columns">
               <form id="contactForm" name="contactForm" onSubmit={handleSubmit}>
                  <fieldset>
                     <div>
                        <label htmlFor="contactName">{ui.name} <span className="required">*</span></label>
                        <input value={name} type="text" size="35" id="contactName" name="contactName" onChange={e => setName(e.target.value)} required />
                     </div>
                     <div>
                        <label htmlFor="contactEmail">{ui.email} <span className="required">*</span></label>
                        <input value={email} type="email" size="35" id="contactEmail" name="contactEmail" onChange={e => setEmail(e.target.value)} required />
                     </div>
                     <div>
                        <label htmlFor="contactSubject">{ui.subject}</label>
                        <input value={subject} type="text" size="35" id="contactSubject" name="contactSubject" onChange={e => setSubject(e.target.value)} />
                     </div>
                     <div>
                        <label htmlFor="contactMessage">{ui.message} <span className="required">*</span></label>
                        <textarea value={message} onChange={e => setMessage(e.target.value)} cols="50" rows="15" id="contactMessage" name="contactMessage" required></textarea>
                     </div>
                     <div>
                        <button type='submit' className="submit">{ui.submit}</button>
                        <span id="image-loader">
                           <img alt="" src="images/loader.gif" />
                        </span>
                     </div>
                  </fieldset>
               </form>

            </div>

            <aside className="four columns footer-widgets">
               <div className="widget widget_contact">
                  <h4>{ui.addressAndPhone}</h4>
                  <p className="address">
                     {data?.name}<br />
                     {data?.address.city}, {data?.address.state}<br />
                     {data?.address.country}<br />
                     <span>{data?.phone}</span>
                  </p>
               </div>
               <div className="widget widget_tweets">
               </div>
            </aside>
         </div>
      </section>
   );
}

export default Contact;
